import { Id } from '@/infra/id'
import { Model, type ModelProps } from '@/infra/model'
import { observable } from 'mobx'
import type { LegendServiceType } from './legend-service-type'

export type LegendSettingsProps = ModelProps<LegendSettings>

export default class LegendSettings extends Model<LegendSettings> {
  static readonly none = new LegendSettings()

  @observable
  accessor id: Id = Id.none

  @observable
  accessor version = 0

  @observable
  accessor imageUrl = ''

  @observable
  accessor name = ''

  @observable
  accessor ratingConfig: RatingConfig | null = null

  @observable
  accessor workspaceId = Id.none

  @observable
  accessor serviceType: LegendServiceType = 'Tax'
}

export interface RatingConfig {
  proRatingEnabled: boolean
  platformRatingEnabled: boolean
  customerRatingMethod: 'Thumb' | 'Star'
}
